<!--Base for modal windows with animation. Have slot for content-->
<!-- example usage for vue2
   <ModalHOC :show="showModal" @update:show="showModal = $event"
             :has-close-icon="false"
             :is-close-by-click-outside="false">
        <div style="background-color: white; padding: 30px; border-radius: 10px">
            <p>Вы выиграли!</p>
        </div>
    </ModalHOC>
-->
<template>
    <div class="modal" v-if="show" @click="isCloseByClickOutside ? hide() : null">
        <div @click.stop class="modal-content">
            <slot></slot>
        </div>
        <!--        Иконка крестик (закрыть) -->
        <button v-if="hasCloseIcon" class="close-button" @click="hide">
            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
                    fill="#FFFFFF"/>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ModalHOC',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        hasCloseIcon: {
            type: Boolean,
            default: true
        },
        isCloseByClickOutside: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        hide() {
            this.$emit('update:show', false);
            document.body.classList.remove('modal-open'); // Remove the class when hiding the modal
        }
    },
    watch: {
        show: function (newVal) {
            if (newVal) {
                document.body.classList.add('modal-open'); // Add the class when showing the modal
            } else {
                document.body.classList.remove('modal-open'); // Remove the class when hiding the modal
            }
        }
    }
}
</script>

<style scoped>
.modal {
    z-index: 999;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    display: flex;
    animation: modal-fade-in 0.5s;
}

.modal-content {
    margin: auto;
    min-height: 50px;
    min-width: 300px;
    animation: modal-content-fade-in 0.5s;
}

@keyframes modal-fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes modal-content-fade-in {
    from {
        transform: scale(0.2);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}

.close-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px;
}
</style>
